import React, { useState, useEffect } from 'react';
import { Link as ScrollLink } from 'react-scroll';
import { images } from '../utils/imagePaths';
import '../styles/header.css';
import LoginDropdown from "../components/LoginDropdown";

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [activeSection, setActiveSection] = useState('home');
    const [scrolled, setScrolled] = useState(false);

    const menuItems = [
        { id: 'home', label: 'Home', target: 'home' },
        { id: 'about', label: 'About us', target: 'about' },
        { id: 'products', label: 'Products', target: 'products' },
        { id: 'client-testimonials', label: 'Testimonials', target: 'client-testimonials' },
        { id: 'contact-us', label: 'Contact Us', target: 'contact-us' },
    ];

    useEffect(() => {
        const onScroll = () => {
            setScrolled(window.scrollY > 60);

            let current = 'home';
            menuItems.forEach(item => {
                const section = document.getElementById(item.target);
                if (section) {
                    const top = section.offsetTop - 120;
                    const height = section.offsetHeight;
                    if (window.scrollY >= top && window.scrollY < top + height) {
                        current = item.target;
                    }
                }
            });
            setActiveSection(current);
        };

        window.addEventListener('scroll', onScroll);
        onScroll();
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    return (
        <header className={`header ${scrolled ? 'scrolled' : ''}`}>
            <div className="container">
                <div className="header-wrapper">

                    <ScrollLink
                        to="home"
                        smooth
                        duration={500}
                        offset={-80}
                        className="logo"
                    >
                        <img src={images.logo} alt="XQlusive Softwares" />
                    </ScrollLink>

                    <nav className={`header-nav ${isMenuOpen ? 'open' : ''}`}>
                        <ul className="menu">
                            {menuItems.map(item => (
                                <li
                                    key={item.id}
                                    className={`menu-item ${activeSection === item.target ? 'active' : ''}`}
                                >
                                    <ScrollLink
                                        to={item.target}
                                        smooth
                                        duration={500}
                                        offset={-80}
                                        onClick={() => setIsMenuOpen(false)}
                                    >
                                        {item.label}
                                    </ScrollLink>
                                </li>
                            ))}
                        </ul>
                    </nav>
                    <LoginDropdown />
                    <div
                        className={`mob-menu ${isMenuOpen ? 'open' : ''}`}
                        onClick={() => setIsMenuOpen(!isMenuOpen)}
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>

                </div>
            </div>
        </header>
    );
};

export default Header;
